module.exports = __webpack_public_path__ + "static/media/contact.c1dda496.jpg";